export function hideChat() {
  window.duet?.close();
  window.duet?.hide();
}

export function unHideChat() {
  window.duet?.unhide();
}
